import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewBrassFixmethod extends BaseScrewFixmethod {
  positions() {
    const { badgeName, material, color, widthPx, heightPx } = this.state
    const positions = []
    let diameter = Calc.mmToPx(4.3)
    let headDiameter = Calc.mmToPx(8)
    let distance = 0

    const brushed = material === "brass" && color === "#ffe472"

    switch (badgeName) {
      case "madrid":
        headDiameter = Calc.mmToPx(5.4)
        distance = Calc.mmToPx(4)
        diameter = Calc.mmToPx(3.2)
        break
      case "london":
        headDiameter = Calc.mmToPx(6.6)
        distance = Calc.mmToPx(9)
        diameter = material === "nickel" && color === "#e3e0db" ? Calc.mmToPx(6.8) : Calc.mmToPx(8)
        break
      case "oslo":
        headDiameter = Calc.mmToPx(5.5)
        distance = Calc.mmToPx(9)
        diameter = Calc.mmToPx(5.6)
        break
      case "paris":
        headDiameter = Calc.mmToPx(6.3)
        distance = Calc.mmToPx(6.5)
        diameter = Calc.mmToPx(7.2)
        break
      case "stockholm":
        headDiameter = Calc.mmToPx(6.6)
        distance = Calc.mmToPx(10.5)
        diameter = material === "brass" ? Calc.mmToPx(6.8) : Calc.mmToPx(6.4)
        break
      case "berlin":
      case "copenhagen":
      case "athens":
      case "amsterdam":
      case "tallinn":
        headDiameter = Calc.mmToPx(6.6)
        distance = Calc.mmToPx(6.5)
        diameter = material === "brass" ? Calc.mmToPx(7.5) : Calc.mmToPx(7)
        break
      case "rome":
        headDiameter = brushed ? Calc.mmToPx(5.5) : Calc.mmToPx(6.6)
        diameter = brushed ? Calc.mmToPx(5.2) : Calc.mmToPx(7.2)
        distance = Calc.mmToPx(7)
        break
      case "sydney":
        headDiameter = Calc.mmToPx(5.5)
        distance = Calc.mmToPx(7.5)
        diameter = Calc.mmToPx(5.5)
        break
      case "budapest":
        headDiameter = Calc.mmToPx(5.4)
        distance = Calc.mmToPx(5.75)
        diameter = Calc.mmToPx(3.5)
        break
      case "kiev":
        headDiameter = Calc.mmToPx(5.4)
        distance = Calc.mmToPx(5.75)
        diameter = Calc.mmToPx(3.5)
        break
    }

    const left = distance - diameter / 2
    const top = distance - diameter / 2
    const bottom = heightPx - distance - diameter / 2
    const right = widthPx - distance - diameter / 2
    const centerV = heightPx / 2 - diameter / 2
    const flathead = !(
      (material === "nickel" && ["madrid", "kiev", "budapest"].includes(badgeName || "")) ||
      ["copenhagen", "athens", "amsterdam", "tallinn"].includes(badgeName || "")
    )
    const fourScrews = ["berlin", "rome", "sydney", "copenhagen", "athens", "amsterdam", "tallinn"].includes(
      badgeName || ""
    )

    const defaults = { diameter, headDiameter, flathead }

    if (fourScrews) {
      positions.push({ ...defaults, left, top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top })
      positions.push({ ...defaults, left: right, top: bottom })
    } else {
      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    }

    return positions
  }
}
